import React from "react";

const filterBearingItems = (searchBy) => (row) => {
    if (!searchBy || !searchBy.trim()) return true;

    const search = searchBy.toLowerCase();

    const matchesAsset = row.car.toLowerCase().includes(search)
        || row.bogie.toLowerCase().includes(search)
        || row.wheel.toLowerCase().includes(search);
    const matchesCondition = row.conditions.findIndex(condition => condition.name.toLowerCase().includes(search)) !== -1;
    return matchesAsset || matchesCondition;
}

const filterCarListItems = (searchBy) => (row) => {
  if (!searchBy || !searchBy.trim()) return true;
  const search = searchBy.toLowerCase();

  return row.car_id.toLowerCase().includes(search) || row.trainLineNumber.toLowerCase().includes(search);
}

const splitForHighlighting = (text, searchBy) => {
    try {
        return text.replace(
            new RegExp(searchBy, 'gi'),
            (str) => `<--->${str}<--->`
        ).split('<--->');
    } catch (invalidRegexError) {
        return [text];
    }
}

const getHighlightedText = (text, searchBy) => {
    if (!searchBy || !searchBy.trim()) return text;

    // https://stackoverflow.com/a/47676769
    let highlightsSplit = splitForHighlighting(text, searchBy);

    if (highlightsSplit.length >= 2) {
        // Every other element
        for (let i = 1; i < highlightsSplit.length; i += 2) {
            // Avoids XSS by not injecting html directly
            highlightsSplit[i] = (<span key={"highlight" + i} className="search-highlight">{highlightsSplit[i]}</span>);
        }
    }

    return highlightsSplit;
};

export {filterBearingItems, filterCarListItems, getHighlightedText}